import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import * as fromStore from 'src/app/_store/_reducers';
import { UserActions } from 'src/app/_store/_user/actions';
import { WelcomeFeature } from 'src/app/_shared/classes/features';

@Component({
  selector: 'app-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrls: ['./welcome-dialog.component.scss'],
  imports: [MatIcon, MatButton, AsyncPipe, TranslateModule],
})
export class WelcomeDialogComponent {
  @Output() closed = new EventEmitter<void>();
  welcomeFeatureFlag$: Observable<WelcomeFeature>;
  constructor(private store: Store<fromStore.State>) {
    this.welcomeFeatureFlag$ = this.store.select(fromStore.getFeatureHeader).pipe(
      take(1),
      map((headerFeatureFlag) => headerFeatureFlag?.welcome)
    );
  }

  closeDialog(): void {
    this.store.dispatch(
      UserActions.updateUserPreferences({
        payload: { property: { welcomeMessage: false } },
      })
    );
    this.closed.emit();
  }
}
